import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ExperiencesListingComponents } from './experiences-listing.components';

export const ExperiencesListingRoute: Routes = [
    {
        path: '',
        component: ExperiencesListingComponents,
    },
];